// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// signIn: this.domainName + `/login?response_type=` + this.code + `&client_id=`+ this.clientId +`&redirect_uri=` + this.redirectUri,

const signInConfig = {
  WEB_PROTOCOL:'https://',
  //DOMAIN_NAME: 'cbm-admin-dev.auth.ap-southeast-1.amazoncognito.com',
  DOMAIN_NAME: 'dev-cbm-admin.auth.ap-southeast-1.amazoncognito.com',
  //CLIENT_ID: '4efofql74344qlibvqoag249d4',
  CLIENT_ID: 'f8e0phja34ceud1kf4nrko29n',
  RESPONSE_TYPE: 'code',  // or 'token', note that REFRESH token will only be generated when the responseType is code
  // REDIRECT_SIGN_IN: 'http://localhost:4201/login',
  // REDIRECT_SIGN_OUT: 'http://localhost:4201',
  REDIRECT_SIGN_IN: 'https://dev.cbm-admin.meco-soldel.com/login',
  REDIRECT_SIGN_OUT: 'https://dev.cbm-admin.meco-soldel.com',
  USER_POOL_ID: 'ap-southeast-1_PcyqJKQbG',
  IDENTITY_POOL_ID: 'ap-southeast-1:54a262b4-6b63-4f36-b539-f151deb1d188',
  SCOPE: [ 'email', 'openid', 'aws.cognito.signin.user.admin'],
}

export const environment = {
  production: false,

  // DEFAULT PAGES
  frontliner_home: 'service-request/search',
  systemAdmin_home: 'service-request/search',

  //ERROR DONT LOGIN AGAIN
  block_login: 'block-new-login',

  //CHANGE PASS
  //changePass_home: 'change-pass',

  //MEMBERTYPES
  memTypeEnv: 'dev',

  
  //DEFAULT USER PROFILE
  defaultUserProfileID: '8a12b1ec-b922-441a-84cb-9be9365fc38b',


  // API FOR CBM - NEO4J
  hostURL: 'https://cbm-api.dev.meco-soldel.com',
  // hostURL: 'https://sqt.cbm-api.meco-soldel.com',
  
  //'https://n6toe4u4j8.execute-api.ap-southeast-1.amazonaws.com',
  //'https://dev.cbm-api.meco-soldel.com',

  // AMPLIFY environments
  domainName: `${signInConfig.DOMAIN_NAME}`,
  userPoolId: `${signInConfig.USER_POOL_ID}`,
  identityPoolId: `${signInConfig.IDENTITY_POOL_ID}`,
  clientId: `${signInConfig.CLIENT_ID}`,
  responseType: `${signInConfig.RESPONSE_TYPE}`,
  redirectUri: `${signInConfig.REDIRECT_SIGN_IN}`,
  redirectSignIn: `${signInConfig.REDIRECT_SIGN_IN}`,
  redirectSignOut: `${signInConfig.REDIRECT_SIGN_OUT}`,
  scope: `${signInConfig.SCOPE}`,
  signIn: `${signInConfig.WEB_PROTOCOL}${signInConfig.DOMAIN_NAME}/login?response_type=${signInConfig.RESPONSE_TYPE}&client_id=${signInConfig.CLIENT_ID}&redirect_uri=${signInConfig.REDIRECT_SIGN_IN}`,
  signOut: `${signInConfig.WEB_PROTOCOL}${signInConfig.DOMAIN_NAME}/logout?client_id=${signInConfig.CLIENT_ID}&logout_uri=${signInConfig.REDIRECT_SIGN_OUT}`,
  // signOut: `${signInConfig.WEB_PROTOCOL}${signInConfig.DOMAIN_NAME}/logout?client_id=${signInConfig.CLIENT_ID}&logout_uri=${encodeURIComponent(signInConfig.REDIRECT_SIGN_OUT)}`,

  //AWS S3 REPORTS ACCESS
  MONTHLY_FOLDER: 'AutomatedReport/monthly/',
  DAILY_FOLDER: 'AutomatedReport/daily/',
  BUCKET: 'cbm-documents-sqt',
  region: 'ap-southeast-1',
  s3URL: '.s3.ap-southeast-1.amazonaws.com/'
 
};
// https://cbm-admin-dev.auth.ap-southeast-1.amazoncognito.com/login?client_id=4efofql74344qlibvqoag249d4&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+profile&redirect_uri=https://dev.cbm-admin.meco-soldel.com/login